"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = exports.ENV = exports.isReactNative = exports.isBrowser = void 0;
const config_1 = require("../config");
exports.isBrowser = process.env.BUILD_TARGET === 'client';
exports.isReactNative = !!global.HermesInternal;
var ENV;
(function (ENV) {
    ENV["SANDBOX"] = "sandbox";
    ENV["STAGE"] = "stage";
    ENV["PROD"] = "prod";
    ENV["NONE"] = "none";
})(ENV || (exports.ENV = ENV = {}));
const getEnv = () => {
    const config = (0, config_1.getGlobalConfig)();
    const apiUrl = config === null || config === void 0 ? void 0 : config.API_URL;
    if (!apiUrl)
        return ENV.NONE;
    if (apiUrl.includes('sandbox')) {
        return ENV.SANDBOX;
    }
    else if (apiUrl.includes('stage')) {
        return ENV.STAGE;
    }
    else {
        return ENV.PROD;
    }
};
exports.getEnv = getEnv;
//# sourceMappingURL=index.js.map